// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false
};

// High Performance Version 本番環境
  export const API_BASE_URL = ".";

// ローカル環境
// export const API_BASE_URL = "http://localhost:8080";

// Old Version
//export const API_BASE_URL = "http://127.0.0.1:8080";
// export const API_BASE_URL = "http://54.248.213.204";
// export const API_BASE_URL = "http://54.178.141.91:8080";

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
